<template>
  <div class="home-page">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <sidebar></sidebar>
    <div class="main-content">
      <section class="header">
        <div class="welcome-header">
          <h1>Bem-vindo {{ userName }}</h1>
          <p>{{ userType }}</p>
        </div>
      <div  class="period-filter-container">
        <b-field :label="'Selecionar período'" class="period-filter">
          <b-select
            @input="onPeriodChange()"
            v-model="periodFilter"
            placeholder="Período"
          >
            <option
              v-for="period in periods"
              :key="period.id"
              :value="period.id"
              :disabled="period.disabled"
            >
              {{ period.name }}
            </option>
          </b-select>
        </b-field>

        <b-field class="period-date">
          <b-datepicker
            @input="onDateChange()"
            :placeholder="'Selecionar data'"
            :years-range="[-100, 100]"
            :date-formatter="bDateRangeFormatter"
            v-model="dates"
            :min-date = "mindate"
            icon="calendar-today"
            range
          >
          </b-datepicker>
        </b-field>
      </div>
      </section>
      <div class="container-fluid">
        <div class="row">
        <div class="col">
        <users-card></users-card>
         <span style="padding-left:20px" />
        <finance-card></finance-card>
        </div>
        <div class="col">
          <points-card></points-card>
        <span style="padding-left:20px" />
        <redemptions-card></redemptions-card>
        </div>
        </div>
      </div>
      <section class="redemptions-summary">
        <button
          @click="exportDashboard()"
          :disabled="isExportingPrizes"
          class="dashboard-btn"
        >
          <b-icon size="is-small" icon="download"></b-icon>
          baixar relatório
        </button>
        <redemptions-summary-table
          @onDetailClick="onRedemptionDetailClick"
        ></redemptions-summary-table>
      </section>
    </div>
  </div>
</template>

<script>
import DashboardService from '@/services/dashboard.service';
import Sidebar from '@/components/HomePage/Sidebar.vue';
import UsersCard from '@/components/HomePage/UsersCard.vue';
import RedemptionsCard from '@/components/HomePage/RedemptionsCard.vue';
import RedemptionsSummaryTable from '@/components/HomePage/RedemptionsSummaryTable.vue';
import FinanceCard from '@/components/HomePage/FinanceCard.vue';
import PointsCard from '@/components/HomePage/PointsCard.vue';
import AwardsByDayModal from '@/components/Modals/AwardsByDayModal.vue';
import PERIODS from '@/constants/periods.constants';
import BuefyMixin from '@/mixins/BuefyMixin';
import { AdminTypeLabel } from '@/enums/AdminTypeEnum';
import { LOAD } from '@/store/actions/dashboard';
import { mapState } from 'vuex';
import flattenDeep from 'lodash/flattenDeep';
import * as moment from 'moment';

export default {
  name: 'home-page',
  mixins: [BuefyMixin],
  components: {
    Sidebar,
    UsersCard,
    RedemptionsCard,
    RedemptionsSummaryTable,
    PointsCard,
    FinanceCard
  },
  data: () => {
    return {
      periods: PERIODS,
      periodFilter: null,
      isExportingPrizes: false,
      dates: [],
      mindate: new Date(2022, 3, 1),
      today: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    userName() {
      return this.$store.getters.userName;
    },
    userType() {
      return AdminTypeLabel.get(this.user.type);
    },
    ...mapState({
      hasLoaded: (state) => state.dashboard.loaded,
      isLoading: (state) => state.dashboard.loading,
      hasError: (state) => state.dashboard.error,
      points: (state) => state.dashboard.points,
      balance: (state) => state.dashboard.balance,
    }),
  },
  methods: {
    load() {
      const period = this.periods.find((item) => item.id == this.periodFilter);
      const { start, end } = period;
      this.dates = [start, end];

      this.$store.dispatch(LOAD, period);
    },
    onDateChange() {
      const [start, end] = this.dates;
      this.periodFilter = 1;
      this.$store.dispatch(LOAD, { id: 1, start, end });
    },
    onPeriodChange() {
      this.load();
    },
    onRedemptionDetailClick({ data, premiacoes }) {
      this.$buefy.modal.open({
        parent: this,
        component: AwardsByDayModal,
        trapFocus: true,
        hasModalCard: true,
        props: {
          date: data,
          awards: premiacoes,
        },
      });
    },
    getPeriod() {
      return this.periods.find((item) => item.id == this.periodFilter);
    },
    exportDashboard() {
      this.isExportingPrizes = true;

      const FORMAT = 'YYYY-MM-DD';
      const [start, end] = this.dates;
      const awardsIds = flattenDeep(
        this.$store.state.dashboard.redemptions.map(({ premiacoes }) => {
          return premiacoes.map((premiacao) => premiacao.id_premiacao);
        })
      );

      DashboardService.export(
        moment(start).format(FORMAT),
        moment(end).format(FORMAT),
        [...new Set(awardsIds)]
      )
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExportingPrizes = false));
    },
  },
  mounted() {
    const { start, end, period } = this.$store.state.dashboard;
    this.periodFilter = period;
    this.dates = [start, end];
    if (!this.hasLoaded) this.load();
  },
};
</script>

<style lang="scss" scoped>

.home-page {
  display: flex;
  position: relative;
}

.main-content {
  flex: 1;
  margin-right: 250px;
}

.period-filter-container {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border-radius: 30px;
  z-index: 2;
 

  .period-date {
    border: none;
    margin-left: 15px;
    border-radius: 30px;
  }

  .period-filter{
    border: none;
    border-radius: 30px;
    }
    
  .select {
    background-color: #fff;
    border-color: #ced4da;
    border-radius: 30px;
    color: #495057;
}
}
 
button.dashboard-btn {
  padding: 8px 12px;
  background: #fff;
  border: none;
  border-radius: 30px;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);
  color: var(--text-color);
  margin-bottom: 12px;
  transition: all 0.2s ease-in-out;
  float: right;
  cursor: pointer;

  &:disabled {
    color: #ccc;
    cursor: not-allowed;

    .icon {
      color: #ccc;
    }
  }

  &:hover:not(:disabled) {
    color: var(--color-primary);
  }

  .icon {
    color: var(--color-primary);
  }
}

section.balance-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 24px;

  .balance-card {
    display: flex;
    flex-direction: column;
    align-self: stretch;
    padding: 12px 32px 12px 12px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);
    margin-right: 8px;
    margin-bottom: 8px;
    position: relative;

    &:hover {
      h2 {
        color: var(--color-primary);
      }
    }

    &::after {
      content: '';
      background: var(--color-primary-shade);
      border-radius: 50%;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 10px;
      right: 10px;
    }

    h2 {
      font-size: 1.2rem;
      font-weight: 600;
      transition: 200ms ease-in-out;
    }

    p {
      font-size: 0.9rem;
    }
  }
}

section.redemptions-summary {
  margin-top: 16px;
}

section.top-cards {
  display: grid;
  margin-top: 24px;

  > * {
    flex: 1;

    &:first-child {
      margin-right: 16px;
    }
  }
}

section.bottom-cards {
  display: flex;
  margin-top: 24px;

  > * {
    flex: 1;

    &:first-child {
      margin-right: 16px;
    }
  }
}

section.header {
  display: flex;
  justify-content: space-between;

  .welcome-header {
    h1 {
      font-size: 1.7rem;
      font-weight: 600;
    }
  }

  .points-container {
    display: flex;

    .points-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      background: #fff;
      border-radius: 10px;
      padding: 16px;
      margin-left: 16px;
      min-width: 170px;
      box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

      h1 {
        font-size: 1.4rem;
      }

      p {
        font-size: 0.9rem;
      }

      &.blue {
        background: var(--color-secondary);
        min-width: 240px;

        h1 {
          font-size: 2rem;
        }

        h1,
        p {
          color: #fff;
        }
      }

      &::after {
        content: '';
        background: var(--color-primary-shade);
        border-radius: 50%;
        width: 10px;
        height: 10px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }
}
</style>
